
import Vue from 'vue'

import login from './Login.vue'
import Register from './Register.vue'

const Instance = Vue.extend(login);
const element = new Instance().$mount();

const promp = {
    open() {       
        document.body.appendChild(element.$el);
    },
    close() {
        document.body.removeChild(element.$el);
    }
}

export default promp;